import { JOB_OPTIONS } from "@/lib/jobs";

export const PlayerEditor = ({ player, onChange }) => {
  if (!player) {
    return <p className="text-sm font-semibold text-[var(--muted)]" data-testid="edit-select-hint">Tap a defender to select. Drag to move.</p>;
  }
  return (
    <div className="space-y-2" data-testid="player-editor">
      <div className="flex items-center gap-2">
        <span className="font-heading text-2xl font-extrabold" data-testid="selected-player-pos">{player.pos}</span>
        <select data-testid="player-job-select" className="field-input flex-1" value={player.job} onChange={(e) => onChange({ job: e.target.value })}>
          {JOB_OPTIONS.map((j) => <option key={j.value} value={j.value}>{j.label}</option>)}
        </select>
      </div>
      <input data-testid="player-label-input" className="field-input w-full" maxLength={20} value={player.label} placeholder="Short label"
        onChange={(e) => onChange({ label: e.target.value })} />
      <textarea data-testid="player-note-input" className="field-input w-full min-h-[64px]" maxLength={200} value={player.note || ""}
        placeholder="Coaching note for this player (optional)" onChange={(e) => onChange({ note: e.target.value })} />
    </div>
  );
};
